import { EnumOrganizationMemberPermissions } from '@/helpers/enums/permissions.enum';

export const checklist = {
  root: {
    name: 'Checklist',
    path: '/checklist',
    title: 'header.checklist',
    icon: 'mdi-format-list-checks',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Checklist`,
      memberPermissions: [
        EnumOrganizationMemberPermissions.AccessSkillsDevelopment,
      ],
    },
  },
};
